import Stack from './StackClient';
import { Screen } from '../views/Screen';

Stack.Screen = Screen;

export { Stack };

export default Stack;
